module.exports = __webpack_public_path__ + "web/img/sfzz.c9305610.png";